import React from 'react'

import {
  EyeSvg,
  ClickSvg,
  DoubleCheckSvg,
  WebSvg
} from '../../components/Icons'

import { parseTextToHTML } from '../../libs/parse'
import { ElementClicksTag } from './ElementClickTag'

const SUGGESTION_ELEMENT = 'suggestion'

export const TextStats = ({ elementInfo, onNavigateToStep }) => {
  const hasSuggestions = elementInfo?.suggestions && Array.isArray(elementInfo.suggestions) && elementInfo.suggestions.length > 0
  
  // Debug logging
  if (hasSuggestions) {
    console.log('[TextStats] Suggestions received:', elementInfo.suggestions)
    elementInfo.suggestions.forEach((suggestion, idx) => {
      console.log(`[TextStats] Suggestion ${idx}:`, {
        suggestion,
        text: suggestion?.text || suggestion?.displayText || 'NO TEXT',
        clicks: suggestion?.clicks || 0
      })
    })
  }
  
  return (
    <section id="textColumn" className="w-full max-w-md">
      <div
        id="textBallon"
        className="w-full p-4 bg-blue-100 rounded-tr-xl rounded-tl-xl rounded-bl-xl mb-4"
      >
        <p className="text-gray-900">{elementInfo?.text && parseTextToHTML(elementInfo.text)}</p>
      </div>
      <div id="suggestionsGroup" className="flex flex-col gap-2">
        {hasSuggestions ? (
          <>
            <h3 className="text-sm font-semibold text-gray-700 mb-2">Response Options:</h3>
            {elementInfo.suggestions.map((suggestion, index) => {
              // Handle both object format {text, clicks} and string format
              // Try multiple possible text fields
              let suggestionData
              if (typeof suggestion === 'string') {
                suggestionData = { text: suggestion, clicks: 0 }
              } else if (suggestion) {
                // Try ALL possible text fields in order of priority
                let text = suggestion.text || 
                       suggestion.displayText || 
                       suggestion.reply?.text || 
                       suggestion.action?.text ||
                       suggestion.reply?.displayText ||
                       suggestion.action?.displayText ||
                       suggestion.reply?.textMessage ||
                       suggestion.action?.textMessage ||
                       ''
                
                // If still no text, try to use postback as fallback identifier
                if (!text || text.trim() === '') {
                  if (suggestion?.postback) {
                    // Try to extract meaningful text from postback
                    const postbackParts = suggestion.postback.split('-')
                    if (postbackParts.length > 1) {
                      // Try to extract meaningful parts
                      const meaningfulParts = postbackParts.slice(1).filter(part => 
                        part && !part.match(/^\d+\/\d+$/) && !part.includes('parent')
                      )
                      if (meaningfulParts.length > 0) {
                        text = meaningfulParts.join(' ').replace(/_/g, ' ').trim()
                      } else {
                        text = postbackParts.slice(1).join(' ').replace(/_/g, ' ').trim()
                      }
                    } else {
                      text = suggestion.postback.replace(/_/g, ' ').trim()
                    }
                  }
                  
                  // Only use "Option N" as absolute last resort
                  if (!text || text.trim() === '') {
                    console.warn(`[TextStats] Suggestion ${index} has no text after all attempts:`, {
                      suggestion,
                      suggestionKeys: Object.keys(suggestion || {}),
                      replyKeys: suggestion.reply ? Object.keys(suggestion.reply) : [],
                      actionKeys: suggestion.action ? Object.keys(suggestion.action) : [],
                      postback: suggestion.postback
                    })
                    // Don't render if we can't find any text
                    return null
                  }
                }
                
                suggestionData = {
                  text: text,
                  clicks: suggestion.clicks || 0,
                  postback: suggestion.postback,
                  openUrl: suggestion.openUrl,
                  type: suggestion.type
                }
              }
              
              if (!suggestionData || !suggestionData.text || suggestionData.text.trim() === '') {
                return null
              }
              
              console.log(`[TextStats] Rendering suggestion ${index}:`, {
                text: suggestionData.text,
                postback: suggestionData.postback,
                hasPostback: !!suggestionData.postback,
                hasOnNavigateToStep: !!onNavigateToStep,
                suggestionData
              })
              
              return (
                <ElementClicksTag
                  key={index}
                  elementInfo={suggestionData}
                  elementType={SUGGESTION_ELEMENT}
                  onClick={onNavigateToStep}
                />
              )
            })}
          </>
        ) : (
          <div className="text-center py-4 text-gray-500 bg-gray-50 rounded-lg border border-gray-200">
            <p className="text-sm italic">No response options available</p>
          </div>
        )}
      </div>
    </section>
  )
}
